export default "__VITE_ASSET__EIaya15j__"